import { Capacitor } from '@capacitor/core'
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'
import { FilePicker } from '@capawesome/capacitor-file-picker'

export function esCancelacionPicker (err) {
  const msg = String((err && (err.message || err.errorMessage)) || err || '')
  return /cancel/i.test(msg)
}

async function webPathToFile (webPath, nameHint) {
  const res = await fetch(webPath)
  const blob = await res.blob()
  const ext = (blob.type && blob.type.split('/')[1]) || 'bin'
  const name = nameHint && String(nameHint).includes('.')
    ? nameHint
    : `${nameHint || 'archivo'}.${ext}`
  return new File([blob], name, { type: blob.type || 'application/octet-stream' })
}

async function pickedFileToFile (picked) {
  if (!picked) return null
  if (picked.blob) {
    return new File(
      [picked.blob],
      picked.name || 'archivo',
      { type: picked.mimeType || picked.blob.type || 'application/octet-stream' }
    )
  }
  if (picked.path) {
    const url = Capacitor.convertFileSrc(picked.path)
    return webPathToFile(url, picked.name || 'archivo')
  }
  if (picked.data) {
    const binary = atob(picked.data)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
    const type = picked.mimeType || 'application/octet-stream'
    return new File([bytes], picked.name || 'archivo', { type })
  }
  return null
}

/** Una foto de la galería vía Photo Picker (sin READ_MEDIA_IMAGES). */
export async function seleccionarFoto () {
  const photo = await Camera.getPhoto({
    source: CameraSource.Photos,
    resultType: CameraResultType.Uri,
    quality: 90,
  })
  if (!photo || !photo.webPath) return null
  return webPathToFile(photo.webPath, `evidencia.${photo.format || 'jpeg'}`)
}

/** Varias fotos de la galería vía Photo Picker. */
export async function seleccionarFotos () {
  const result = await Camera.pickImages({ quality: 90 })
  const photos = (result && result.photos) || []
  const files = []
  for (const photo of photos) {
    if (!photo || !photo.webPath) continue
    files.push(await webPathToFile(photo.webPath, `evidencia.${photo.format || 'jpeg'}`))
  }
  return files
}

/** Un archivo vía selector del sistema (SAF / DocumentsUI, sin galería amplia). */
export async function seleccionarArchivo (types) {
  const result = await FilePicker.pickFiles({
    types: types && types.length ? types : undefined,
    multiple: false,
    readData: false,
  })
  const picked = result && result.files && result.files[0]
  return pickedFileToFile(picked)
}

/** Un video vía selector del sistema (sin acceso amplio a almacenamiento). */
export async function seleccionarVideo () {
  const result = await FilePicker.pickVideos({
    multiple: false,
    readData: false,
  })
  const picked = result && result.files && result.files[0]
  return pickedFileToFile(picked)
}
